export default function ExpertiseComparison() {
  return (
    <section id="comparison" className="py-24 bg-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-teal-600">Nos Deux Expertises</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Quelle Solution pour Votre Projet ?
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Nous proposons deux approches complémentaires selon la complexité et l'envergure de votre projet.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-teal-50 to-white rounded-3xl p-10 shadow-xl border-2 border-teal-100">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-600 rounded-2xl mb-6">
              <i className="ri-tools-fill text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">Expert en Installation CVSE</h3>
            <p className="text-lg text-gray-600 mb-8">
              Spécialiste technique des installations de chauffage, ventilation, sanitaire et électricité.
            </p>
            
            <div className="space-y-6">
              <div>
                <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                  <i className="ri-checkbox-circle-fill text-teal-600 mr-2"></i>
                  Domaines d'Intervention
                </h4>
                <ul className="space-y-2 ml-8 text-gray-600">
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Pompes à chaleur et systèmes de chauffage</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Installations électriques (OIBT/NIBT)</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Plomberie et sanitaire</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Ventilation et VMC</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Domotique et automatisation</span>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                  <i className="ri-star-fill text-teal-600 mr-2"></i>
                  Avantages
                </h4>
                <ul className="space-y-2 ml-8 text-gray-600">
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Expertise technique pointue et spécialisée</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Équipe certifiée et formée en continu</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Matériel professionnel de haute qualité</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Conformité garantie aux normes suisses</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Tarifs optimisés pour travaux CVSE</span>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                  <i className="ri-user-line text-teal-600 mr-2"></i>
                  Idéal Pour
                </h4>
                <ul className="space-y-2 ml-8 text-gray-600">
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Rénovation d'installations existantes</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Remplacement de systèmes de chauffage</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Mise aux normes électriques</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Projets nécessitant une expertise technique</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-white rounded-3xl p-10 shadow-xl border-2 border-orange-100">
            <div className="w-16 h-16 flex items-center justify-center bg-orange-600 rounded-2xl mb-6">
              <i className="ri-building-4-line text-3xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">Entreprise Générale</h3>
            <p className="text-lg text-gray-600 mb-8">
              Coordination complète de tous les corps de métier pour une gestion de projet clé en main.
            </p>
            
            <div className="space-y-6">
              <div>
                <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                  <i className="ri-checkbox-circle-fill text-orange-600 mr-2"></i>
                  Services Inclus
                </h4>
                <ul className="space-y-2 ml-8 text-gray-600">
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Gestion et coordination de projet complète</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Maçonnerie et gros œuvre</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Menuiserie et charpente</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Peinture et finitions</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Tous les corps de métier CVSE</span>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                  <i className="ri-star-fill text-orange-600 mr-2"></i>
                  Avantages
                </h4>
                <ul className="space-y-2 ml-8 text-gray-600">
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Un seul interlocuteur pour tout le projet</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Coordination optimale entre corps de métier</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Gestion des délais et du budget global</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Responsabilité unique et garantie globale</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Livraison clé en main</span>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="font-bold text-gray-900 mb-3 flex items-center">
                  <i className="ri-user-line text-orange-600 mr-2"></i>
                  Idéal Pour
                </h4>
                <ul className="space-y-2 ml-8 text-gray-600">
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Rénovations complètes d'appartements ou villas</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Constructions neuves</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Projets nécessitant plusieurs corps de métier</span>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2">•</span>
                    <span>Clients souhaitant une gestion simplifiée</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
